const sanitizeForSearch = (value: string): string => {
	// remove characthers that are not in the whitelist
	let sanitizedString = value.replace(/[^a-zA-Z0-9\s-@.'_+]/gi, " ");
	sanitizedString = sanitizedString.replace("  ", " ");

	return sanitizedString;
};

export default sanitizeForSearch;
